import * as React from 'react';
import styles from './index.less';
import FDrawer from '@/components/FDrawer';
import { Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import FResourceStatusBadge, {
  resourceStatus_numberToText,
} from '@/components/FResourceStatusBadge';
import FContractHandleDrawer from '@/components/FContractHandleDrawer';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import moment from 'moment';
import fMessage from '@/components/fMessage';
import FIcons from '@/components/FIcons';
import FGlobalLoading from '@/components/FGlobalLoading';

interface FAddResourcesHandleAuthProps {
  collectionID: string;

  resourceIDs: string[];

  isPublish?: boolean;

  onOk?(): void;

  onCancel?(): void;

  onBack?(): void;

  onError?(): void;
}

function FAddResourcesHandleAuth({
  collectionID,
  resourceIDs,
  onOk,
  onCancel,
  onBack,
  isPublish = true,
  onError,
}: FAddResourcesHandleAuthProps) {
  const refPromise = React.useRef<Promise<void> | null>(null);

  const [$resourceIDs, set$resourceIDs, get$resourceIDs] = FUtil.Hook.useGetState<string[]>(
    resourceIDs.slice(0, 50),
  );

  const [$resourcesInfo, set$resourcesInfo, get$resourcesInfo] = FUtil.Hook.useGetState<
    {
      resourceID: string;
      resourceTitle: string;
      cover: string;
      status: 'online' | 'offline' | 'unreleased' | 'freeze';
      resourceType: string[];
      updateDate: string;
      baseUpcastResourceIDs: string[];
      authExcludedItems: {
        resourceID: string;
        resourceName: string;
        contracts: {
          policyID: string;
          contractID: string;
        }[];
      }[];
      isAllAuthComplete: boolean;
    }[]
  >([]);

  // const [$allContract, set$allContract, get$allContract] =
  //   FUtil.Hook.useGetState<
  //     {
  //       resourceId: string;
  //       contracts: {
  //         policyId: string;
  //       }[];
  //     }[]
  //   >([]);

  const [$handleAuthResourceID, set$handleAuthResourceID, get$handleAuthResourceID] =
    FUtil.Hook.useGetState<string>('');

  const [$globalLoading, set$globalLoading, get$globalLoading] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$succeedCount, set$succeedCount, get$succeedCount] = FUtil.Hook.useGetState<number>(0);
  const [$failedList, set$failedList, get$failedList] = FUtil.Hook.useGetState<
    {
      cover: string;
      resourceID: string;
      resourceName: string;
      resourceTitle: string;
      resourceType: string[];
      failedReason: string;
      updateDate: string;
      status: 'online' | 'offline' | 'unreleased' | 'freeze';
    }[]
  >([]);

  React.useEffect(() => {
    set$resourceIDs(resourceIDs.slice(0, 50));
  }, [resourceIDs]);

  AHooks.useDebounceEffect(
    () => {
      handle();
    },
    [$resourceIDs, collectionID],
    {
      wait: 100,
    },
  );

  async function handle() {
    if (collectionID === '' || get$resourceIDs().length === 0) {
      return;
    }
    const {
      data: data_resources,
    }: {
      data: {
        resourceId: string;
        resourceTitle: string;
        coverImages: string[];
        status: number;
        resourceType: string[];
        updateDate: string;
        baseUpcastResources: {
          resourceId: string;
        }[];
      }[];
    } = await FServiceAPI.Resource.batchInfo({
      resourceIds: get$resourceIDs().join(','),
    });

    const resourceIDString: string = data_resources
      .map((r) => {
        return r.baseUpcastResources.map((ai) => {
          return ai.resourceId;
        });
      })
      .flat()
      .join(',');

    let data_contracts: {
      contractId: string;
      subjectId: string;
      policyId: string;
    }[] = [];
    if (resourceIDString !== '') {
      // await addResourcesToCollection();
      // return;

      const {
        data,
      }: {
        data: {
          contractId: string;
          subjectId: string;
          policyId: string;
        }[];
      } = await FServiceAPI.Contract.batchContracts({
        licenseeId: collectionID,
        subjectIds: resourceIDString,
        contractStatus: 0,
      });
      data_contracts = data;
    }
    // console.log(data_resources, 'data_resources *************************************');

    set$resourcesInfo(
      data_resources.map((r) => {
        const baseUpcastResourceIDs: string[] = r.baseUpcastResources.map((bur) => {
          return bur.resourceId;
        });

        const isAllAuthComplete: boolean =
          baseUpcastResourceIDs.length === 0 ||
          baseUpcastResourceIDs.every((buri) => {
            return data_contracts.some((c) => {
              return c.subjectId === buri;
            });
          });

        return {
          resourceID: r.resourceId,
          resourceTitle: r.resourceTitle,
          cover: r.coverImages[0] || '',
          status: resourceStatus_numberToText(r.status),
          resourceType: r.resourceType,
          updateDate: moment(r.updateDate).format('YYYY-MM-DD'),
          baseUpcastResourceIDs: baseUpcastResourceIDs,
          authExcludedItems: [],
          isAllAuthComplete: isAllAuthComplete,
        };
      }),
    );

    // set$allContract(result);
    await addResourcesToCollection();
  }

  async function addResourcesToCollection() {
    // console.log(get$resourcesInfo(), 'get$resourcesInfo() *************************************');
    if (
      get$resourcesInfo().some((ri) => {
        return !ri.isAllAuthComplete;
      })
    ) {
      return;
    }

    set$globalLoading(true);
    const {
      ret,
      errCode,
      msg,
      data: data_addResourceItemsResult,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        addSuccessfulItems: {
          itemTitle: string;
          resourceId: string;
        }[];
        addFailedItems: {
          itemName: string;
          reason: string;
          resourceId: string;
        }[];
        ignoreItems: {
          itemId: string;
          itemTitle: string;
          resourceId: string;
        }[];
      };
    } = await FServiceAPI.Resource.addResourceItems_Draft({
      resourceId: collectionID,
      addCollectionItems: get$resourcesInfo().map((resource) => {
        return {
          resourceId: resource.resourceID,
          itemTitle: resource.resourceTitle || '（无标题）',
          authExcludedItems: resource.authExcludedItems
            .map((ai) => {
              return ai.contracts.map((c) => {
                return {
                  resourceId: ai.resourceID,
                  excludedType: 'contractId' as const,
                  excludedValue: c.policyID,
                };
              });
            })
            .flat(),
        };
      }),
      isPublish: isPublish ? 1 : 0,
    });

    set$globalLoading(false);
    await refPromise.current;

    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      onError?.();
      return;
    }

    set$succeedCount(
      data_addResourceItemsResult.addSuccessfulItems.length +
        data_addResourceItemsResult.ignoreItems.length,
    );
    if (data_addResourceItemsResult.addFailedItems.length > 0) {
      const { data: data_batchResourcesInfo } = await FServiceAPI.Resource.batchInfo({
        resourceIds: data_addResourceItemsResult.addFailedItems
          .map((r) => {
            return r.resourceId;
          })
          .join(','),
      });
      // console.log(data, 'data sdifjalskdjflsdjlkfjlksdjlkj');

      set$failedList(
        data_batchResourcesInfo.map((d: any) => {
          const failedReason: string =
            data_addResourceItemsResult.addFailedItems.find((fr) => {
              return fr.resourceId === d.resourceId;
            })?.reason || '';
          return {
            cover: d.coverImages[0],
            resourceID: d.resourceId,
            resourceName: d.resourceName,
            resourceTitle: d.resourceTitle,
            resourceType: d.resourceType,
            failedReason: failedReason,
            updateDate: moment(d.updateDate).format('YYYY-MM-DD'),
            status: resourceStatus_numberToText(d.status),
          };
        }),
      );
    }
  }

  return (
    <>
      <FDrawer
        open={
          collectionID !== '' &&
          $resourceIDs.length > 0 &&
          $resourcesInfo.some((ri) => {
            return !ri.isAllAuthComplete;
          })
        }
        width={740}
        title={'未授权'}
        topRight={
          <Space size={30}>
            <FComponentsLib.FTextBtn
              type='default'
              onClick={() => {
                set$handleAuthResourceID('');
                onCancel?.();
              }}
            >
              取消
            </FComponentsLib.FTextBtn>

            <FComponentsLib.FTextBtn
              type='default'
              onClick={() => {
                onBack?.();
              }}
            >
              上一步
            </FComponentsLib.FTextBtn>
          </Space>
        }
      >
        <FComponentsLib.FContentText
          type={'additional2'}
          text={'以下单品或其上抛未获得授权，点击对应条目解决相关问题'}
        />
        <div style={{ height: 10 }} />
        <div className={styles.resourceList}>
          {$resourcesInfo
            // .filter((r) => {
            //   return (
            //     r.baseUpcastResourceIDs.length > 0 &&
            //     r.baseUpcastResourceIDs.some((buri) => {
            //       const contractInfo = get$allContract().find((c) => {
            //         return c.resourceId === buri;
            //       });
            //       // console.log(contractInfo, 'contractInfo isdojf;lksdjfl;kdsjlkfjklsdjfkldsjlkjlk');
            //       return (contractInfo?.contracts?.length ?? 0) === 0;
            //     })
            //   );
            // })
            .filter((r) => {
              return !r.isAllAuthComplete;
            })
            .map((r) => {
              return (
                <div
                  className={styles.card}
                  key={r.resourceID}
                  onClick={() => {
                    set$handleAuthResourceID(r.resourceID);
                  }}
                >
                  <div style={{ position: 'relative' }}>
                    <FCoverImage src={r.cover} width={64} style={{ borderRadius: 4 }} />
                    <FResourceStatusBadge
                      status={r.status}
                      style={{ position: 'absolute', top: 4, left: 4 }}
                    />
                  </div>
                  <div>
                    <FComponentsLib.FContentText
                      type={'highlight'}
                      text={r.resourceTitle}
                      singleRow={true}
                      style={{ maxWidth: 560 }}
                    />
                    <div style={{ height: 10 }} />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={`${r.resourceType.join('/')} | 最近更新${r.updateDate}`}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </FDrawer>

      <FContractHandleDrawer
        // open={$handleAuthResourceID === '' ? 0 : Math.random()}
        open={$handleAuthResourceID === '' ? 0 : Math.random()}
        // open={0}
        licensorId={$handleAuthResourceID}
        licenseeId={collectionID}
        authExcludedItems={
          $resourcesInfo.find((ri) => {
            return ri.resourceID === get$handleAuthResourceID();
          })?.authExcludedItems || []
        }
        onUpdate={(data) => {
          set$resourcesInfo(
            get$resourcesInfo().map((ri) => {
              if (ri.resourceID === get$handleAuthResourceID()) {
                return {
                  ...ri,
                  authExcludedItems: data.authExcludedItems,
                  isAllAuthComplete: data.isAllAuthComplete,
                };
              }
              return ri;
            }),
          );
          // console.log(
          //   get$resourcesInfo(),
          //   ' get$resourcesInfo() *************************************',
          // );
        }}
        onClose={async () => {
          // console.log('onClose, w234098rfjuioesdlkfjsad;lkfjl;ksdjlk;fjlskdjflksjdlfkjsldkj');
          set$handleAuthResourceID('');

          const needHanldeBaseUpcastResourceIDs: string[] = get$resourcesInfo()
            .filter((ri) => {
              return !ri.isAllAuthComplete;
            })
            .flatMap((ri) => {
              return ri.baseUpcastResourceIDs;
            });
          // .flat();
          if (needHanldeBaseUpcastResourceIDs.length > 0) {
            const {
              data: data_contracts,
            }: {
              data: {
                contractId: string;
                subjectId: string;
                policyId: string;
              }[];
            } = await FServiceAPI.Contract.batchContracts({
              licenseeId: collectionID,
              subjectIds: needHanldeBaseUpcastResourceIDs.join(','),
              contractStatus: 0,
            });

            set$resourcesInfo(
              get$resourcesInfo().map((r) => {
                if (r.isAllAuthComplete) {
                  return r;
                }

                const baseUpcastResourceIDs: string[] = r.baseUpcastResourceIDs;

                const isAllAuthComplete: boolean = baseUpcastResourceIDs.every((buri) => {
                  return data_contracts.some((c) => {
                    return c.subjectId === buri;
                  });
                });

                return {
                  ...r,
                  isAllAuthComplete: isAllAuthComplete,
                };
              }),
            );
          }
          addResourcesToCollection();
        }}
      />

      <FGlobalLoading
        open={$globalLoading}
        onOpened={(promise) => {
          refPromise.current = promise;
        }}
        onClosed={() => {}}
      />

      <FDrawer
        open={$succeedCount > 0 || $failedList.length > 0}
        title={<div />}
        width={700}
        onClose={() => {
          set$succeedCount(0);
          set$failedList([]);
        }}
        afterOpenChange={(o) => {
          if (!o) {
            onOk?.();
          }
        }}
      >
        {$succeedCount > 0 && (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 15,
                fontSize: 14,
                fontWeight: 600,
                color: '#42C28C',
                flexDirection: 'column',
                height: $failedList.length > 0 ? 'auto' : 'calc(100vh - 200px)',
              }}
            >
              <FIcons.FCheck
                style={{
                  fontSize: 64,
                  color: '#42C28C',
                }}
              />
              <div>已加入合集</div>
            </div>
            <div style={{ height: 50 }} />
          </>
        )}

        {$failedList.length > 0 && (
          <>
            <FComponentsLib.FContentText type={'negative'} text={'以下资源加入合集失败：'} />
            <div style={{ height: 10 }} />
            <div style={{ maxHeight: 260, overflowY: 'auto', paddingRight: 10 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  gap: 5,
                }}
              >
                {$failedList.map((v) => {
                  return (
                    <div
                      key={v.resourceID}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: 68,
                        // borderBottom: '1px solid #E5E7EB',
                        background: 'rgba(0,0,0,0.03)',
                        borderRadius: 10,
                        padding: '0 10px',
                      }}
                    >
                      <Space size={10}>
                        <div
                          style={{
                            width: 'fit-content',
                            height: 'fit-content',
                            cursor: 'pointer',
                            position: 'relative',
                          }}
                          onClick={() => {
                            self.open(
                              FUtil.LinkTo.resourceDetails({
                                resourceID: v.resourceID,
                              }),
                            );
                          }}
                        >
                          <FCoverImage src={v.cover} width={64} style={{ borderRadius: 4 }} />

                          <FResourceStatusBadge
                            status={v.status}
                            style={{ position: 'absolute', top: 4, left: 4 }}
                          />
                        </div>
                        <div>
                          <FComponentsLib.FContentText
                            type={'highlight'}
                            text={v.resourceTitle || v.resourceName.split('/')[1]}
                            singleRow
                            style={{ maxWidth: 400 }}
                          />
                          <div style={{ height: 10 }} />
                          <FComponentsLib.FContentText
                            type={'additional2'}
                            // text={v.resourceType}
                            text={`${v.resourceType.join('/')} | 最近更新${v.updateDate}`}
                            singleRow
                            style={{ maxWidth: 400 }}
                          />
                        </div>
                      </Space>

                      <FComponentsLib.FContentText
                        type={'additional2'}
                        text={v.failedReason}
                        style={{ color: '#EE4040' }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </FDrawer>
    </>
  );
}

export default FAddResourcesHandleAuth;

// function check(
//   resourcesInfo: {
//     resourceID: string;
//     resourceTitle: string;
//     cover: string;
//     status: 'online' | 'offline' | 'unreleased' | 'freeze';
//     resourceType: string[];
//     updateDate: string;
//     baseUpcastResourceIDs: string[];
//   }[],
//   allContracts: {
//     resourceId: string;
//     contracts: {
//       policyId: string;
//     }[];
//   }[],
// ) {
//   return resourcesInfo.every((ri) => {
//     return ri.baseUpcastResourceIDs.every((id) => {
//       const cInfo = allContracts.find((ac) => {
//         return ac.resourceId === id;
//       });
//       return cInfo && cInfo.contracts.length > 0;
//     });
//   });
// }
